import PrivatePolicyModal from './PrivatePolicyModal';

export default PrivatePolicyModal;
